import { useEffect } from 'react';
import { useContactsListStore } from '../ContactsList.store';

export const useClearStateOnTabChange = () => {
	const { setState, tab } = useContactsListStore();
	useEffect(() => {
		setState({ checkedMap: {}, checkMode: 'single-select' });
	}, [tab]);
};
